import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSortDown, faSortUp} from "@fortawesome/free-solid-svg-icons";
import {BADGE_COLOR, ORGANIZATION_TYPE_MAP, VACCINE_TYPE_MAP} from "../../../../utils/constants";
import {MedicalOrganizationVaccine} from "../../../../types/MedicalOrganizationVaccine";
import {ActionButton} from "../../../../designSystem/components/ActionButton";

interface MedicalOrganizationTableProps {
  data: MedicalOrganizationVaccine[];
  sortColumn: string;
  sortOrder: 'asc' | 'desc';
  handleSort: (value: string) => void;
  handleEdit: (item: MedicalOrganizationVaccine) => void;
  handleDelete: (item: MedicalOrganizationVaccine) => void;
}

const MedicalOrganizationTable = ({
  data,
  handleSort,
  sortColumn,
  sortOrder,
  handleEdit,
  handleDelete,
}: MedicalOrganizationTableProps) => (
  <div>
    <div className="hidden md:block">
      <table className="w-full table-fixed border shadow-lg rounded-2xl overflow-hidden">
        <thead>
          <tr className="bg-white">
            <th
              className="p-2 border cursor-pointer w-24"
              onClick={() => handleSort("category")}
            >
              類別{" "}
              {sortColumn === "name" && <FontAwesomeIcon icon={sortOrder === "asc" ? faSortUp : faSortDown}/>}
            </th>
            <th
              className="p-2 border cursor-pointer w-[200px]"
              onClick={() => handleSort("name")}
            >
              名稱{" "}
              {sortColumn === "role" && <FontAwesomeIcon icon={sortOrder === "asc" ? faSortUp : faSortDown}/>}
            </th>
            <th className="p-2 border">
              疫苗
            </th>
            <th className="p-2 border resize-x overflow-auto w-[200px]">
              動作
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={item.id} className="border bg-white">
              <td className="p-2 border text-center text-gray-500">
                <FontAwesomeIcon icon={ORGANIZATION_TYPE_MAP[item.category].icon} className={"mr-2"}/>
                {item.category}
              </td>
              <td className="p-2 border max-w-[200px] overflow-x-auto whitespace-nowrap">
                {item.name}
              </td>
              <td className="p-2 border">
                <div className="flex flex-row flex-wrap mt-1">
                  {item.vaccines?.length > 0 && item.vaccines.map((category, index) => (
                    <div
                      key={`category-${index}`}
                      className={`
                        text-sm mr-1 mb-1 py-0.5 px-2 text-white rounded-lg
                        ${BADGE_COLOR[category].color}
                      `}
                    >
                      {VACCINE_TYPE_MAP[category].shortName}
                    </div>
                  ))}
                </div>
              </td>
              <td className="border pl-1">
                <ActionButton
                  size="sm"
                  label="修改"
                  iconName="fa-edit"
                  onClick={() => handleEdit(item)}
                  variant="ghost"
                />
                <ActionButton
                  size="sm"
                  label="刪除"
                  iconName="fa-trash"
                  onClick={() => handleDelete(item)}
                  color="warning"
                  variant="ghost"
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)

export default MedicalOrganizationTable;
